import { render } from "./WhatsappCodeListPage.vue?vue&type=template&id=2abdd7d8&ts=true"
import script from "./WhatsappCodeListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhatsappCodeListPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-code/WhatsappCodeListPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2abdd7d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2abdd7d8', __exports__)) {
    api.reload('2abdd7d8', __exports__)
  }
  
  module.hot.accept("./WhatsappCodeListPage.vue?vue&type=template&id=2abdd7d8&ts=true", () => {
    api.rerender('2abdd7d8', render)
  })

}


export default __exports__